import {DI_TOKENS} from '@/di/di.tokens';

import {injected} from 'brandi';

import {QueryStringService} from '@/services/QueryStringService/QueryStringService';
import {AppName, GlobalWindow, Platform} from '@/types';

export class PlatformService {
  private platform?: Platform;
  private appName?: AppName | null;
  private isIos: boolean = false;

  constructor(private readonly queryStringService: QueryStringService, private globalWindow: GlobalWindow) {}

  public init = (): void => {
    this.appName = this.queryStringService.getAppName() as AppName | null;
    this.platform = this.queryStringService.getMobileVersion() !== null ? 'mb' : 'web';
    this.isIos = /iPhone|iPad|iPod/i.test(this.globalWindow.navigator?.userAgent);
  };

  public getPlatform = (): Platform | undefined => {
    return this.platform;
  };

  public getAppQueryString = (): string => {
    if (this.platform === 'mb') {
      return `mbversion=${this.queryStringService.getMobileVersion()}`;
    }

    if (this.appName !== null) {
      return `appName=${this.appName}&appVersion=${this.queryStringService.getAppVersion()}`;
    }

    return '';
  };

  public isMb = (): boolean => {
    return this.platform === 'mb' || this.appName === 'mb';
  };

  public isInvesting = (): boolean => {
    return this.appName === 'investing';
  };

  public isApp = (): boolean => {
    return this.isMb() || this.isInvesting();
  };

  public detectIsIos = (): boolean => {
    return this.isIos;
  };
}

injected(PlatformService, DI_TOKENS.queryStringService, DI_TOKENS.globalWindow);
